import React, { useEffect, useRef, useState } from 'react';
import { getApi, putApi, postApi } from '../../../Services/apiService';
import { checkAddPermission, checkEditPermission, checkDeletePermission,  checkViewPermission, checkCurrentOrBeforeDate, dateFormat, fetchBrandFilter, fetchCategoryDataFilter, fetchOriginDataFilter, filteredCategories, handleExportFileProduct, handleExportFileReserve, handleGetCustomerGroupFilter, handleImportClickFile, handleSelectionChange, relatedProductsLoadOptions, TableFooter } from '../../../Utils/helper';
import Category from '../Category/category';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import Import from '../../../Utils/import';
import AddEditReserve from './addEditReserve';
import { AsyncPaginate } from 'react-select-async-paginate';
import MultiSelectDropdown from '../../../Utils/multiSelectDropdown';
import ViewReserve from './viewReserve';
import Modal from 'react-modal';
import SingleEditReserve from './singleEditReserve';
import { toast } from 'react-toastify';
import {  useSelector } from 'react-redux';
import { format } from 'date-fns';

function Reserve() {
  const dropdownRef = useRef();
  const { RangePicker } = DatePicker;
    const { data } = useSelector((state) => state.roleData);
  const reserveMethod = localStorage.getItem('reserveMethod')
  const [showAddReserve, setShowAddReserve] = useState(reserveMethod || false);
  const [methodType, setMethodType] = useState('');
  const [dateRange, setDateRange] = useState([null, null]);
  const [promotionDateRange, setPromotionDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [promotionStartDate, promotionEndDate] = promotionDateRange;
  const [reserveData, setReserveData] = useState([])
  const [perPage, setPerPage] = useState(50)
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(null)
  const [categoryData, setCategoryData] = useState([])
  const [filterDatas, setFilterData] = useState([])
  const [originData, setOriginData] = useState([])
  const [brandData, setBrandData] = useState([])
  const [customerGroupData, setCustomerGroupData] = useState([])
  const [customerSubGroupData, setCustomerSubGroupData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([])
  const [selectedCustomerIds, setSelectedCustomerIds] = useState([])
  const [selectedOriginIds, setSelectedOriginIds] = useState([])
  const [selectedBrandName, setSelectedBrandName] = useState([])
  const [brandOpen, setBrandOpen] = useState(false)
  const [originOpen, setOriginOpen] = useState(false)
  const [categoryOpen, setCategoryOpen] = useState(false)
  const [customerGroupOpen, setCustomerGroupOpen] = useState(false)
  const [searchTerm, setSearchTerm] = useState('');
  const [reserveViewHistoryData, setReserveViewHistoryData] = useState([]);
  const [idProductMap, setIdProductMap] = useState({});
  const [viewHistoryModal, setViewHistoryModal] = useState(false);
  const [reserveToEdit, setReserveToEdit] = useState(false);
  const [dateState, setDateState] = useState({
    startDate: dayjs().startOf('month').format('YYYY-MM-DD'),
    endDate: dayjs().endOf('month').format('YYYY-MM-DD')
  });
  const [showImportModal, setShowImportModal] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importErrors, setImportErrors] = useState({
    file: '',
    general: ''
  });
  const [isOpen, setIsOpen] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [reserveEdit, setReserveEdit] = useState({})
  const [searchQuery, setSearchQuery] = useState('')
  const [selectedReserveIds, setSelectedReserveIds] = useState([]);
  const [showBatchModal, setShowBatchModal] = useState(false);
  const [batchTargetProduct, setBatchTargetProduct] = useState(null);
  const [isBatchUpdating, setIsBatchUpdating] = useState(false);


  const [formData, setFormData] = useState({
    customerGroup: '',
    product: '',
    promotionType: '',
    dateRange: [{
      start: null,
      end: null
    }],
    promotionDateRange: [
      {
        start: null,
        end: null
      }
    ],
    DateRangeData: [

    ]
  });

  useEffect(() => {
    const handleKeyDown = (event) => {
      // ESC key closes any open modal
      if (event.key === 'Escape' && isOpen) {
        setIsOpen(false)
      }
      // Enter key submits the form in modals
      if ((event.key === 'Enter'||event.key === 'return') && isOpen) {
        event.preventDefault();
        document.getElementById('modal-save-btn')?.click();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);

  const toggleAddReserve = () => {
    setFormData({
      customerGroup: '',
      product: '',
      promotionType: '',
      dateRange: [{
        start: null,
        end: null
      }],
      promotionDateRange: [
        {
          start: null,
          end: null
        }
      ],
      DateRangeData: [

      ]
    });
    if (methodType === '') {
      setShowAddReserve(!showAddReserve);
    }
    if (methodType === 'edit') {
      setMethodType('')
    }
    localStorage.removeItem('reserveMethod')
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setCustomerGroupOpen(false);
        setBrandOpen(false)
        setCategoryOpen(false)
        setOriginOpen(false)
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (searchTerm !== '') {
      if (categoryOpen) {
        const data = filteredCategories(searchTerm, categoryData);
        setFilterData(data?.length > 0 ? data : []);
      } else if (originOpen) {
        const data = filteredCategories(searchTerm, originData);
        setFilterData(data?.length > 0 ? data : []);
      } else if (brandOpen) {
        const data = filteredCategories(searchTerm, brandData);
        setFilterData(data?.length > 0 ? data : []);
      } else if (customerGroupOpen) {
        const data = filteredCategories(searchTerm, customerGroupData);
        setFilterData(data?.length > 0 ? data : []);
      }
    }
  }, [searchTerm])



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleCustomerGroupId = (e) => {
    const { name, value } = e.target;
    const selectedCategory = customerSubGroupData.find(cat => cat?.id === value);
    if (selectedCategory) {
      setFormData(prev => ({
        ...prev,
        // [name]: value,
        ['customer_sub_group_id']: selectedCategory?.id
      }));

    }
  }

  useEffect(() => {
    if (formData.dateRange[0]?.start && formData.dateRange[0]?.end) {
      const startDate = dayjs(formData.dateRange[0].start);
      const endDate = dayjs(formData.dateRange[0].end);
      const promoStart = formData.promotionDateRange[0]?.start ? dayjs(formData.promotionDateRange[0].start) : null;
      const promoEnd = formData.promotionDateRange[0]?.end ? dayjs(formData.promotionDateRange[0].end) : null;

      const daysDiff = endDate.diff(startDate, 'day');
      const newDateRangeData = [];

      for (let i = 0; i <= daysDiff; i++) {
        const currentDate = startDate.add(i, 'day');
        const dateStr = currentDate.format('YYYY-MM-DD');

        const currentDateStr = currentDate.format('YYYY-MM-DD');
        const promoStartStr = promoStart ? promoStart.format('YYYY-MM-DD') : null;
        const promoEndStr = promoEnd ? promoEnd.format('YYYY-MM-DD') : null;

        const isInPromoRange = promoStartStr && promoEndStr &&
          currentDateStr >= promoStartStr &&
          currentDateStr <= promoEndStr;
        // if (isInPromoRange && formData.promotionType) {
        // if (isInPromoRange ) {
        newDateRangeData.push({
          date: dateStr,
          quantity: '',
          promotionType: isInPromoRange ? formData.promotionType : ''
        });
        // }
      }

      setFormData(prev => ({
        ...prev,
        DateRangeData: newDateRangeData
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        DateRangeData: []
      }));
    }
  }, [
    formData.dateRange,
    formData.promotionDateRange,
    formData.promotionType
  ]);

  const handleReserveQuantityChange = (index, value) => {
    const updatedQuantities = [...formData.DateRangeData];
    updatedQuantities[index].quantity = value;
    setFormData(prev => ({
      ...prev,
      DateRangeData: updatedQuantities
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', {
      ...formData,
      dateRange: {
        start: startDate,
        end: endDate
      },
      promotionDateRange: {
        start: promotionStartDate,
        end: promotionEndDate
      }
    });
    toggleAddReserve();
  };

  const handleReset = () => {
    setDateRange([null, null]);
    setPromotionDateRange([null, null]);
    setFormData({
      customerGroup: '',
      product: '',
      promotionType: '',
      reserveQuantities: [
        { date: '2024-12-28', quantity: '', type: 'VIP' },
        { date: '2024-12-28', quantity: '', type: 'VIP' }
      ]
    });
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);

  useEffect(() => {
    handleFetchData()
  }, [perPage, currentPage, selectedBrandName, selectedCategoryIds, selectedOriginIds, selectedCustomerIds, dateState, searchQuery])

  const handleFetchData=async()=>{
    if(selectedBrandName?.length>0 || selectedCategoryIds?.length>0 || selectedCustomerIds?.length>0 || selectedOriginIds?.length>0|| searchQuery!==''){
    await getReserveData()
    }else{
      setReserveData([])
      setPageCount(null)
    }
  }
  useEffect(() => {
    handleGetCategory('', setCategoryData)
    handleGetOrigin('', setOriginData)
    handleGetBrand('', setBrandData)
    handleGetCustomerGroup('', setCustomerGroupData)
    handleGetCustomerSubGroup()
  }, [])

  const handleGetCategory = async () => {
    const resp = await getApi(`/product-category?per_page=100`)
    if (resp?.success) {
      setCategoryData(resp?.data?.productCategories?.data)
    }
  }
  const handleGetOrigin = async () => {
    const resp = await getApi(`/product-origin?per_page=100`)
    if (resp?.success) {
      setOriginData(resp?.data?.productOrigins?.data)
    }
  }
  const handleGetBrand = async () => {
    const resp = await getApi(`/brand`)
    if (resp?.success) {
      setBrandData(resp?.data?.brands)
    }
  }
  const handleGetCustomerGroup = async () => {
    const resp = await getApi(`/customer-group?per_page=999&&only_customer_groups=1`)
    if (resp?.success) {
      setCustomerGroupData(resp?.data?.customerGroups?.data)
    }
  }
  const handleGetCustomerSubGroup = async () => {
    const resp = await getApi(`/customer-sub-group?per_page=100`)
    if (resp?.success) {
      setCustomerSubGroupData(resp?.data?.customerSubGroups)
    }
  }

  const getReserveData = async () => {
    setIsLoading(true)
    const queryParams = new URLSearchParams();
    if (Array.isArray(selectedCategoryIds)) {
      selectedCategoryIds.forEach((id) => queryParams.append('category_ids[]', id));
    } else if (selectedCategoryIds) {
      queryParams.append('category_ids[]', selectedCategoryIds);
    }
    if (Array.isArray(selectedOriginIds)) {
      selectedOriginIds.forEach((id) => queryParams.append('origin_ids[]', id));
    } else if (selectedOriginIds) {
      queryParams.append('origin_ids[]', selectedOriginIds);
    }
    if (Array.isArray(selectedCustomerIds)) {
      selectedCustomerIds.forEach((id) => queryParams.append('customer_group_ids[]', id));
    } else if (selectedCustomerIds) {
      queryParams.append('customer_group_ids[]', selectedCustomerIds);
    }
    if (Array.isArray(selectedBrandName)) {
      selectedBrandName.forEach((id) => queryParams.append('brands[]', id));
    } else if (selectedBrandName) {
      queryParams.append('brands[]', selectedBrandName);
    }
    queryParams.append('per_page', perPage);
    queryParams.append('page', currentPage);
    queryParams.append('from_date', dateState?.startDate);
    queryParams.append('to_date', dateState?.endDate);
    queryParams.append('search', searchQuery);

    const resp = await getApi(`/reserve?${queryParams.toString()}`)
    if (resp?.success) {
      setReserveData(resp?.data?.reserves?.data)
      setPageCount(resp?.data?.reserves?.last_page)
    }
    setIsLoading(false)
  }

  const handlePageClick = (selected) => {
    setCurrentPage(selected);
  };

  const handleCategoryChange = (e) => {
    const selectedName = e;
    const selectedCategory = categoryData.find(cat => cat.name === selectedName);

    if (selectedCategory) {
      setSelectedCategoryIds(prevIds => {
        return prevIds.includes(selectedCategory.id)
          ? prevIds.filter(id => id !== selectedCategory.id)
          : [...prevIds, selectedCategory.id];
      });

    }
  };
  const handleCustomerChange = (e) => {
    const selectedName = e;
    const selectedCustomer = customerGroupData.find(cat => cat.group_id === selectedName);

    if (selectedCustomer) {
      setSelectedCustomerIds(prevIds => {
        return prevIds.includes(selectedCustomer.group_id)
          ? prevIds.filter(id => id !== selectedCustomer.group_id)
          : [...prevIds, selectedCustomer.group_id];
      });

    }
  };

  const handleOriginChange = (e) => {
    const selectedName = e;
    const selectedOrigin = originData.find(cat => cat.name === selectedName);

    if (selectedOrigin) {
      setSelectedOriginIds(prevIds => {
        return prevIds.includes(selectedOrigin.id)
          ? prevIds.filter(id => id !== selectedOrigin.id)
          : [...prevIds, selectedOrigin.id];
      });

    }
  };
  const handleBrandChange = (e) => {
    const selectedName = e;
    const selectedOrigin = brandData.find(cat => cat === selectedName);

    if (selectedOrigin) {
      setSelectedBrandName(prevIds => {
        return prevIds.includes(selectedOrigin)
          ? prevIds.filter(id => id !== selectedOrigin)
          : [...prevIds, selectedOrigin];
      });

    }
  };

  // const handleDateFilterChange = (dates) => {
  //   if (dates) {
  //     setDateState({
  //       startDate: dates[0] ? dayjs(dates[0]).format('YYYY-MM-DD') : null,
  //       endDate: dates[1] ? dayjs(dates[1]).format('YYYY-MM-DD') : null
  //     });
  //   } else {
  //     setDateState({
  //       startDate: null,
  //       endDate: null
  //     });
  //   }

  // }
  const handleDateFilterChange = (dates) => {
    if (!dates || dates.length === 0 || !dates[0] || !dates[1]) {
      setDateState({ startDate: null, endDate: null });
    } else {
      setDateState({
        startDate: dayjs(dates[0]).format('YYYY-MM-DD'),
        endDate: dayjs(dates[1]).format('YYYY-MM-DD'),
      });
    }
  };

  const handleViewHistory = async (reserve) => {
    setReserveToEdit(reserve)
    const resp = await getApi(`/reserve/${reserve?.id}`)
    if (resp?.success) {
      const histories = resp?.data?.histories || {};
      const slicedHistory = Object.entries(histories)
        .sort(([dateA], [dateB]) => new Date(dateB) - new Date(dateA));

      const sortedHistory = slicedHistory;
      // const sortedHistory = slicedHistory.length === 2 
      //   ? slicedHistory.slice(0, 1)
      //   : slicedHistory.slice(0, 2);

      const latestTwoEntries = sortedHistory.reduce((result, [date, value]) => {
        result[date] = value;
        return result;
      }, {});

      // Collect all unique product IDs from history and reserveToEdit
      const productIds = new Set();
      if (reserve?.product_id) productIds.add(reserve.product_id);

      Object.values(histories).forEach(changes => {
        changes.forEach(change => {
          if (change.column_name === 'product_id') {
            if (change.old_value) productIds.add(change.old_value);
            if (change.new_value) productIds.add(change.new_value);
          }
        });
      });

      if (productIds.size > 0) {
        const queryParams = Array.from(productIds).map(id => `product_ids[]=${id}`).join('&');
        const prodResp = await getApi(`/product?per_page=99&${queryParams}`);
        if (prodResp?.success) {
          const map = {};
          prodResp.data.products.data.forEach(p => {
            map[p.id] = p;
          });
          setIdProductMap(map);
        }
      }

      setReserveViewHistoryData(latestTwoEntries)
    }
    setViewHistoryModal(true)
  }

  // const handleEditReserve =async(x)=>{
  //   setFormData({
  //     id:x?.id,
  //     customerGroup: x?.customer_group_name,
  //     customersubgroup:x?.customer_sub_group_name,
  //     product: x?.product_code,
  //     promotionType: x?.promotion_type,
  //     product_code:x?.product_code,
  //     specification:x?.specification,
  //     quantity:x?.quantity,
  //     dateRange: [{
  //       start: x?.date,
  //       end: x?.date
  //     }],
  //     promotionDateRange: [
  //       {
  //         start: null,
  //         end: null
  //       }
  //     ],
  //     DateRangeData: [{
  //       start: x?.date,
  //       end: x?.date
  //     }
  //     ]
  //   });

  //   setMethodType('edit')

  // }
  const handleSelectReserve = (id) => {
    setSelectedReserveIds(prev => 
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  const handleSelectAllReserves = (e) => {
    if (e.target.checked) {
      setSelectedReserveIds(reserveData.map(r => r.id));
    } else {
      setSelectedReserveIds([]);
    }
  };

  const handleBatchUpdate = async () => {
    if (selectedReserveIds.length === 0) {
      toast.error("Please select at least one reserve to update");
      return;
    }
    if (!batchTargetProduct) {
      toast.error("Please select a target product");
      return;
    }

    setIsBatchUpdating(true);
    try {
      const response = await postApi('/reserve/batch-update-product-code', {
        reserve_ids: selectedReserveIds,
        target_product_id: batchTargetProduct?.value
      });
      if (response.success === true) {
        toast.success(response.msg || "Reserves successfully updated");
        setShowBatchModal(false);
        setSelectedReserveIds([]);
        setBatchTargetProduct(null);
        handleFetchData(); // Refresh table
      } else {
        toast.error(response.msg || "Failed to batch update reserves");
      }
    } catch (error) {
      console.error("Batch update error:", error);
      toast.error("Failed to batch update reserves");
    } finally {
      setIsBatchUpdating(false);
    }
  };

  const handleEdit = (x) => {
    setIsOpen(true)
    setReserveEdit(x)
  }

  const handleUpdateReserveData = async () => {
    try {
      setIsSubmitting(true)
      const urlEncodedData = new URLSearchParams();
      urlEncodedData.append('quantity', reserveEdit?.quantity);
      urlEncodedData.append('promotion_type', reserveEdit?.promotion_type || '');

      const response = await putApi(`/reserve/${reserveEdit?.id}`, urlEncodedData.toString());

      if (response?.success === true) {
        toast.success(response.msg || 'Reserve added successfully');
        handleFetchData();
        setIsOpen(false)
        // toggleAddReserve();
      } else {
        toast.error(response?.msg || 'Failed to add reserve');
      }
    } catch (error) {
      const errorMsg = error.response?.data?.msg || error.message || 'Failed to add reserve';
      toast.error(errorMsg);
      console.error('Error submitting reserve:', error);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="RightSideDiv reserve">
      {/* {showImportModal &&

<Import setImportFile={setImportFile} importFile={importFile} searchQuery={''} fetchData={getReserveData} setShowImportModal={setShowImportModal} routeEnd={'/product/import'} routeexport={'/product/export'} type='Product' />
} */}
      {/* Main Reserve Table Section - Only show when not showing Add Reserve */}
      {(!showAddReserve && methodType !== 'view' && methodType !== 'edit') && (
        <div className="row">
          <div className="col-sm-12">
            <div className="setting-right setting-right-table table-border-show product-grouping arrival">
              <div className="table-header">
                <div className="header-left">
                  <div className="table-second py-0">
                    <div className="links position-relative">
                      <div class="search-card">
                        <img
                          src={window.getPublicUrl(
                            "/assets/images/search-icon.svg"
                          )}
                          alt=""
                        />
                        <input
                          type="text"
                          class="search-input"
                          placeholder="Search Product code/name."
                          value={searchQuery}
                          onChange={(e) => {setSearchQuery(e.target.value);setCurrentPage(1)}}
                        />
                      </div>
                      <div className='selctions-option'>
                        <RangePicker
                          key={'pathName'}
                          onChange={handleDateFilterChange}
                          separator={'-'}
                          value={[
                            dateState.startDate ? dayjs(dateState.startDate) : null,
                            dateState.endDate ? dayjs(dateState.endDate) : null
                          ]}
                          allowClear={false}
                        // placeholder={[t('FROM'), t('TO')]}
                        // disabledDate={(current) => current && current < dayjs().startOf('day')}
                        />
                      </div>

                  
                        <MultiSelectDropdown
                          categoryData={customerGroupData}
                          selectedCategories={selectedCustomerIds}
                          setSelectedCategories={setSelectedCustomerIds}
                          placeholder="Select customer group..."
                          noOptionsMessage='No customer group available'
                          setCurrentPage={setCurrentPage}
                          fetchOptionsApi={handleGetCustomerGroupFilter}
                        />
                      
                        <MultiSelectDropdown
                          categoryData={categoryData}
                          selectedCategories={selectedCategoryIds}
                          setSelectedCategories={setSelectedCategoryIds}
                          placeholder='Select Categories...'
                          noOptionsMessage='No categories available'
                          setCurrentPage={setCurrentPage}
                          fetchOptionsApi={fetchCategoryDataFilter}
                        />
                    
                        <MultiSelectDropdown
                          categoryData={originData}
                          selectedCategories={selectedOriginIds}
                          setSelectedCategories={setSelectedOriginIds}
                          placeholder="Select origin..."
                          noOptionsMessage='No origin available'
                          setCurrentPage={setCurrentPage}
                          fetchOptionsApi={fetchOriginDataFilter}
                        />
             
                        <MultiSelectDropdown
                          categoryData={brandData}
                          selectedCategories={selectedBrandName}
                          setSelectedCategories={setSelectedBrandName}
                          placeholder="Select brand..."
                          noOptionsMessage='No Brand available'
                          setCurrentPage={setCurrentPage}
                          fetchOptionsApi={fetchBrandFilter}
                        />
                    
                    </div>
                  </div>
                         {/* <div className="table-actions"> */}
                  <button className="btn" onClick={() => setShowBatchModal(true)} disabled={selectedReserveIds.length === 0}>
                    Batch Update
                  </button>
                  <button className="btn" onClick={() => handleExportFileReserve(reserveData, dateState?.startDate, dateState?.endDate, 'reserve.xlsx', '/reserve/export', selectedBrandName, selectedOriginIds, selectedCategoryIds, selectedCustomerIds,searchQuery)}>
                    <img src={window.getPublicUrl("/assets/images/export.svg")} alt="" />
                    Export
                  </button>
                 {checkAddPermission(data?.permissions, 'reserve') && (
                  <button className="btn add" onClick={toggleAddReserve}>
                    + Add Reserve
                  </button>
                 )}
                {/* </div> */}
                </div>
                {/* <div className="table-actions">
                  <button className="btn" onClick={() => handleExportFileReserve(reserveData, dateState?.startDate, dateState?.endDate, 'reserve.xlsx', '/reserve/export', selectedBrandName, selectedOriginIds, selectedCategoryIds, selectedCustomerIds)}>
                    <img src={window.getPublicUrl("/assets/images/export.svg")} alt="" />
                    Export
                  </button>
                  <button className="btn add" onClick={toggleAddReserve}>
                    + Add Reserve
                  </button>
                </div> */}
              </div>

              <div className="permission-table-inner">
                <table className="custom-table table-striped">
                  <thead>
                    <tr>
                      <th style={{ width: '40px' }}>
                        <input 
                          type="checkbox" 
                          onChange={handleSelectAllReserves}
                          checked={selectedReserveIds.length === reserveData.length && reserveData.length > 0}
                        />
                      </th>
                      <th className="gr-no">Date</th>
                      <th className="code">Customer Group</th>
                      <th className="code">Customer Sub Group</th>
                      <th className="name-en">Product Code</th>
                      <th className="name-en">Product Name</th>
                      <th className="name-tc">Specifications</th>
                      <th className="category actial-stock">Reserve Qty</th>
                      <th className="coo">Promotion Type</th>
                      <th className="coo">Added By</th>
                      <th className="update">Added/Edit at</th>
                      <th className="action">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td colSpan="10" className="text-center">
                          <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </td>
                      </tr>
                    ) : error ? (
                      <tr>
                        <td colSpan="6" className="text-center text-danger">{error}</td>
                      </tr>
                    ) : reserveData?.length === 0 ? (
                      <tr>
                        {(selectedBrandName?.length<=0 || selectedCategoryIds?.length<=0 || selectedCustomerIds?.length<=0 || selectedOriginIds?.length<=0|| searchQuery==='')?
                        <td colSpan="10" className="text-center">{'Please select a filter to view data'}</td>
                      :
                        <td colSpan="10" className="text-center">{'No Reserve found'}</td>
                      }
                      </tr>
                    ) : (
                      reserveData && reserveData?.length > 0 && reserveData?.map((x, index) => {
                      const isCurrentOrBeforeDate = checkCurrentOrBeforeDate(x?.date);

                        return (
                          <tr key={index}>
                            <td>
                              <input 
                                type="checkbox" 
                                checked={selectedReserveIds.includes(x.id)}
                                onChange={() => handleSelectReserve(x.id)}
                              />
                            </td>
                            <td className="gr-no">{x?.date}</td>
                            <td className="code">{x?.customer_group_name}</td>
                            <td className="name-en">{x?.customer_sub_group_name}</td>
                            <td className="name-en">{x?.product_code}</td>
                            <td className="name-tc">{x?.product_name_tc}</td>
                            <td className="name-tc">{x?.specification}</td>
                            <td className="category actial-stock"><input type="text" className={x.is_batch_updated ? 'text-batch-updated' : ''} value={x?.previous_quantity != null ? `${x?.previous_quantity} -> ${x?.quantity}` : x?.quantity}  onClick={() => {
                              if (!isCurrentOrBeforeDate) {
                                handleEdit(x);
                              }
                            }} disabled={isCurrentOrBeforeDate} /></td>
                            {/* <td className="category" onClick={()=>handleEdit(x)}>{x?.quantity}</td> */}
                            {/* <td className="coo">{x?.promotion_type}</td> */}
                            <td className="coo"><input type="text" value={x?.promotion_type != 'null' ? x?.promotion_type : ''} onClick={() => {
                              if (!isCurrentOrBeforeDate) {
                                handleEdit(x);
                              }
                            }} disabled={isCurrentOrBeforeDate}  /></td>
                            <td className="coo">{x?.added_by}</td>
                            <td className="update">
                              {x?.updated_at ? format(new Date(x.updated_at), 'dd MMMM yyyy, hh:mm a') : ''}
                            </td>
                            <td className="action action-cs">
                              <div className="dropdown">

                                {x?.histories_count > 1 && (
                                  <>
                                    <button
                                      className="dropdown-toggle action-btn"
                                      type="button"
                                      id={`dropdownMenuButton-${x.id}`}
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <img src={window.getPublicUrl("/assets/images/dots-icon.svg")} alt="Actions" />
                                    </button>
                                    <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton-${x.id}`}>
                                      {/* <li>
            <a
              href="#"
              className="dropdown-item"
              onClick={(e) => {
                e.preventDefault();
                handleEditReserve(x);
              }}
            >
              Edit
            </a>
          </li> */}
                                      <li>
                                        <a
                                          href="#"
                                          className="dropdown-item"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleViewHistory(x);
                                          }}
                                        >
                                          View History
                                        </a>
                                      </li>
                                    </ul>

                                  </>
                                )}
                              </div>
                            </td>

                          </tr>
                        )
                      })
                    )}
                  </tbody>
                </table>
                {checkEditPermission(data?.permissions, 'reserve') && (
                <Modal
                  isOpen={isOpen}
                  onRequestClose={() => setIsOpen(false)}
                  contentLabel="Example Modal"
                  className="custom-modal add-custom-stock"
                  overlayClassName="custom-overlay"
                  shouldCloseOnOverlayClick={true}
                  ariaHideApp={false}
                >
                  
                  <div className="modal-overlay file-upload-modal">
                    
                    <div className="modal-content">
                      <div className="modal-header">
                        <h3>Actual Stock</h3>
                        <span>
                          <img
                            src={window.getPublicUrl('/assets/images/close.svg')}
                            onClick={() => setIsOpen(false)}
                            className="close"
                            alt="Close"
                          /></span>
                      </div>
                    
                      <div className="modal-body mb-0 p-0">
                        <p>Please enter the updated Reserve Value.</p>
                        <div class="form-group">
                          <label for="actual-stock" className='d-block'>Reserve Quantity</label>
                          <input type="number" class="" id="actual-stock" placeholder="Enter quantity" value={reserveEdit?.quantity ?? ''}
                          // disabled={!checkEditPermission(data?.permissions, 'reserve')}
                            onChange={(e) => setReserveEdit(prev => ({
                              ...prev,
                              quantity: e.target.value
                            }))}
                            onClick={() => {
                              if (reserveEdit?.quantity == 0) {
                                setReserveEdit(prev => ({
                                  ...prev,
                                  quantity: null
                                }))
                              }
                            }}
                          />
                          <label for="actual-stock" className='d-block'>Promotion Type</label>
                          <input type="text" class="" id="actual-stock" placeholder="Enter Promotion Type" value={reserveEdit?.promotion_type}
                            // disabled={!checkEditPermission(data?.permissions, 'reserve')}
                            onChange={(e) => setReserveEdit(prev => ({
                              ...prev,
                              promotion_type: e.target.value
                            }))}
                          />
                        </div>
                      </div>
                       
                      <div className="modal-footer">
                        {/* <button className="reset" onClick=''>
                Reset
              </button> */}
                        <button
                        id='modal-save-btn'
                          className="save mt-0"
                          onClick={() => handleUpdateReserveData()}
                          disabled={isSubmitting}
                        >

                          {isSubmitting && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
                          Save
                        </button>
                      </div>
                    </div>
                  </div>

                </Modal>
                )}
                <Modal
                  isOpen={viewHistoryModal}
                  onRequestClose={() => setViewHistoryModal(false)}
                  contentLabel="History Modal"
                  shouldCloseOnOverlayClick={true}
                  ariaHideApp={false}
                  overlayClassName="modal-overlay add-category delete logout view-history-details"
                  portalClassName="add-user delete inventory-history-cs"
                >
                  <div className='modal-content'>
                    <div className='modal-header'>
                      <h3>History</h3>
                      <img
                        src={window.getPublicUrl('/assets/images/close.svg')}
                        onClick={() => { setViewHistoryModal(false); }}
                        className="close"
                        alt="Close"
                      />
                    </div>
                  <div className='onscroll-history reserve-history'>
                    <div className='modal-body mb-0 p-0'>
                      <div className='permission-table-inner arrival main-head reserve-history'>
                           <div className="mb-4 w-100 d-flex align-items-center ">
                                     <h3> <span>{(() => {
                                        const nextEntry = Object.entries(reserveViewHistoryData);
                                        const lastEntry = nextEntry.at(0);
                                        const nextDate = lastEntry?.[0];
                                        if (nextDate) {
                                          return <h3>{dateFormat(nextDate)}</h3>;
                                        }
                                        return null;
                                      })()}</span></h3>
                        {(() => {
                          const allEntries = Object.entries(reserveViewHistoryData || {}).sort((a, b) => new Date(b[0]) - new Date(a[0]));
                          return (
                            <table className='custom-table table-striped '>
                          <thead>
                            <tr>
                              <th className="gr-no">Date</th>
                              <th className="code">Customer Group</th>
                              <th className="code">Customer Sub Group</th>
                              <th className="name-en">Product Code</th>
                              <th className="name-en">Product Name</th>
                              <th className="name-tc">Specifications</th>
                              <th className="category actial-stock">Reserve Qty</th>
                              <th className="coo">Promotion Type</th>
                              <th className="coo">Added By</th>
                              <th className="coo">Updated By</th>
                              <th className="update">Added/Edit at</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="gr-no">{reserveToEdit?.date}</td>
                              <td className="code">{reserveToEdit?.customer_group_name}</td>
                              <td className="name-en">{reserveToEdit?.customer_sub_group_name}</td>
                              <td className={`name-en ${allEntries[0]?.[1]?.some(c => c.column_name === "product_id") ? 'updated-fw' : ''}`}>{reserveToEdit?.product_code}</td>
                              <td className="name-tc">{reserveToEdit?.product_name_tc}</td>
                              <td className="name-tc">{reserveToEdit?.specification}</td>
                              <td className={`category atd ${allEntries[0]?.[1]?.some(c => c.column_name === "quantity") ? 'updated-fw' : ''}`}>{reserveToEdit?.quantity}</td>
                              <td className="coo">{reserveToEdit?.promotion_type}</td>
                              <td className="coo">{reserveToEdit?.added_by}</td>
                              <td className="coo">{allEntries[0]?.[1]?.[0]?.changed_by}</td>
                              <td className="update">{dateFormat(reserveToEdit?.updated_at)}</td>
                            </tr>
                          </tbody>
                        </table>
                          )
                        })()}
                        </div>
                      </div>
                    </div>

                    <div className='modal-footer text-start justify-content-start'>
                      {/* {reserveViewHistoryData && Object.entries(reserveViewHistoryData).map(([date, changes], index, allEntries) => { */}
                       {reserveViewHistoryData && Object.entries(reserveViewHistoryData).sort((a, b) => new Date(b[0]) - new Date(a[0])).map(([date, changes], index, allEntries) => {
                       if (index === allEntries.length - 1) return null;

                        const sortedEntries = allEntries; // Re-use the already sorted entries from the map

                        const getOldOrCurrentValue = (fieldName, currentValue) => {
                          const productRelatedFields = ["product_code", "product_name_tc", "specification"];
                          
                          if (productRelatedFields.includes(fieldName)) {
                            let currentProductId = reserveToEdit?.product_id;
                            for (let i = 0; i <= index; i++) {
                              const pChange = allEntries[i][1].find(c => c.column_name === 'product_id');
                              if (pChange) {
                                currentProductId = pChange.old_value;
                              }
                            }
                            
                            const product = idProductMap[currentProductId];
                            if (product) {
                              if (fieldName === "product_code") return product.code;
                              if (fieldName === "product_name_tc") return product.name_tc;
                              if (fieldName === "specification") return product.specification;
                            }
                            return reserveToEdit?.[fieldName];
                          }

                          let val = reserveToEdit?.[fieldName];
                          for (let i = 0; i <= index; i++) {
                            const change = allEntries[i][1].find(c => c.column_name === fieldName);
                            if (change) {
                              val = change.old_value;
                            }
                          }
                          return val || currentValue;
                        };
                        const isFieldUpdated = (fieldName) => {
                          if (index === allEntries.length - 2) return false;
                          const nextChanges = allEntries[index + 1]?.[1];
                          if (["product_code", "product_name_tc", "specification"].includes(fieldName)) {
                            return nextChanges?.some(change => change.column_name === "product_id");
                          }
                          return nextChanges?.some(change => change.column_name === fieldName);
                        };

                        return (
                          <div key={index} className="mb-2 w-100 d-flex align-items-center arrival">
                            <h3> <span>{(() => {
                                        const nextEntry = Object.entries(allEntries)[index + 1];
                                        const nextDate = nextEntry?.[1]?.[0];
                                        if (nextDate) {
                                          return <h3>{dateFormat(nextDate)}</h3>;
                                        }
                                        return null;
                                      })()}</span></h3>
                            <table className='custom-table table-striped ms-0'>
                              <tbody>
                                <tr>
                                  <td className="shipping_method_name">{getOldOrCurrentValue("date", reserveToEdit?.date)}</td>
                                  <td className="container-no">{getOldOrCurrentValue("customer_group_name", reserveToEdit?.customer_group_name)}</td>
                                  <td className="order-remark">{getOldOrCurrentValue("customer_sub_group_name", reserveToEdit?.customer_sub_group_name)}</td>
                                  <td className={`atd ${isFieldUpdated("product_code") ? 'updated-fw' : ''}`}>{getOldOrCurrentValue("product_code", reserveToEdit?.product_code)}</td>
                                  <td className="atd"> {getOldOrCurrentValue("product_name_tc", reserveToEdit?.product_name_tc)}</td>
                                  <td className="atd">{getOldOrCurrentValue("specification", reserveToEdit?.specification)}</td>
                                  <td className={`atd ${isFieldUpdated("quantity") ? 'updated-fw' : ''}`}>{getOldOrCurrentValue("quantity", reserveToEdit?.quantity)}</td>
                                  <td className="atd">{getOldOrCurrentValue("promotion_type", reserveToEdit?.promotion_type)}</td>
                                  <td className="atd">{getOldOrCurrentValue("added_by", reserveToEdit?.added_by)}</td>
                                  <td className="atd">{allEntries[index + 1]?.[1]?.[0]?.changed_by}</td>
                                  <td className="atd">{dateFormat(date)}</td>

                                </tr>
                              </tbody>
                            </table>
                          </div>
                        );
                      })}

                    </div>
                    </div>
                  </div>
                </Modal>

              </div>
              <div className="table-footer d-flex justify-content-between table-pagination">
                <select name="" id="" className='affter-change-cs page' value={perPage} onChange={(e) => { setPerPage(Number(e.target.value)); setCurrentPage(1) }}>
                <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="250">250</option>
                    <option value="500">500</option>
                </select>
                <div className=''>
                  <TableFooter
                    pageCount={pageCount}
                    handlePageClick={handlePageClick}
                    currentPage={currentPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showAddReserve && (
        <AddEditReserve toggleAddReserve={toggleAddReserve} formData={formData} handleReserveQuantityChange={handleReserveQuantityChange} handleInputChange={handleInputChange} handleReset={handleReset} customerGroupData={customerGroupData} setFormData={setFormData} handleCustomerGroupId={handleCustomerGroupId} customerSubGroupData={customerSubGroupData} getReserveData={handleFetchData} setFilterData={setFilterData} filterDatas={filterDatas} searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      )}
      {methodType === 'edit' && (
        <SingleEditReserve toggleAddReserve={toggleAddReserve} formData={formData} handleReserveQuantityChange={handleReserveQuantityChange} handleInputChange={handleInputChange} handleReset={handleReset} customerGroupData={customerGroupData} setFormData={setFormData} handleCustomerGroupId={handleCustomerGroupId} customerSubGroupData={customerSubGroupData} getReserveData={handleFetchData} setFilterData={setFilterData} filterDatas={filterDatas} searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      )}
      {methodType === 'view' && (
        <ViewReserve toggleAddReserve={toggleAddReserve} formData={formData} handleReserveQuantityChange={handleReserveQuantityChange} handleInputChange={handleInputChange} handleReset={handleReset} customerGroupData={customerGroupData} setFormData={setFormData} handleCustomerGroupId={handleCustomerGroupId} customerSubGroupData={customerSubGroupData} getReserveData={handleFetchData} setFilterData={setFilterData} filterDatas={filterDatas} searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      )}
      <Modal
        isOpen={showBatchModal}
        onRequestClose={() => {setShowBatchModal(false); setBatchTargetProduct(null);}}
        className="modal-content custom-modal col-sm-6"
        overlayClassName="modal-overlay"
        ariaHideApp={false}
      >
        <div className="modal-header d-flex justify-content-between">
          <h5 className="modal-title">Batch Update Product Code</h5>
          <button type="button" className="close border-0 bg-transparent" onClick={() => setShowBatchModal(false)}>
            <img src={window.getPublicUrl("/assets/images/close.svg")} alt="close" />
          </button>
        </div>
        <div className="modal-body">
          <div className="form-group mb-4">
            <label className="mb-2">Selected Reserves: {selectedReserveIds.length}</label>
          </div>
          <div className="form-group">
            <label className="mb-2">Target Product</label>
            <AsyncPaginate
              value={batchTargetProduct}
              loadOptions={relatedProductsLoadOptions('product')}
              getOptionLabel={(option) => `${option.label}`}
              getOptionValue={(option) => option.value}
              onChange={(value) => setBatchTargetProduct(value)}
              placeholder="Search and select product..."
              additional={{
                page: 1,
              }}
            />
          </div>
        </div>
        <div className="modal-footer mt-4 d-flex justify-content-end gap-2">
          <button className="btn btn-secondary border" onClick={() => setShowBatchModal(false)}>Cancel</button>
          <button 
            className="btn btn-primary" 
            onClick={handleBatchUpdate} 
            disabled={!batchTargetProduct || isBatchUpdating}
          >
            {isBatchUpdating ? 'Updating...' : 'Confirm Update'}
          </button>
        </div>
      </Modal>
    </div>
  );
}

export default Reserve;